/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionAttributeSchema = z.enum(['name', 'email', 'phone', 'contact_consent', 'cv'])

export type QuestionAttributeSchema = z.infer<typeof questionAttributeSchema>
